import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import DrugCategoryForm from "./OverTheCounterForm";

const AddDrugCategory = () => {
  const faqProps = useSelector((state) => state.CurdR);
  const { Add_DrugCategory_Modal, Loader } = faqProps;

  const [form] = Form.useForm();
  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add Over The Counter"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addOTC"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_DrugCategory_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_DrugCategory_Modal ? Add_DrugCategory_Modal : false}
      width={550}
      form={form}
      recordName="overTheCounterList"
    >
      <DrugCategoryForm />
    </FormModal>
  );
};

export default AddDrugCategory;
